<template>
  <div v-if="customer.id">

    <div class="flex flex-wrap -mx-2">
      <div class="w-full lg:w-1/3 xl:w-1/4 px-2">
        <div class="box">
          <contact-information
            :contact="customer"
            contactType="customer"
            @updated="getCustomer"
          ></contact-information>
        </div>
      </div>
      <div class="w-full lg:w-2/3 xl:w-3/4 px-2">
        <div class="box">
          <ul class="flex select-none mb-8">
            <li class="flex-1 mr-2" v-if="hasPermission('job.view')">
              <a
                class="tab"
                :class="{ 'active': tabs.top.active === 'jobs' }"
                @click="tabs.top.active = 'jobs'"
                >
                Jobs
              </a>
            </li>
            <li class="flex-1 mr-2" v-if="hasPermission('vehicle.view')">
              <a
                class="tab"
                :class="{ 'active': tabs.top.active === 'vehicles' }"
                @click="tabs.top.active = 'vehicles'"
                >
                Vehicles
              </a>
            </li>
            <li class="flex-1 mr-2" v-if="hasPermission('customer.edit')">
              <a
                class="tab"
                :class="{ 'active': tabs.top.active === 'edit' }"
                @click="tabs.top.active = 'edit'"
                >
                Edit
              </a>
            </li>
            <li class="flex-1 mr-2" v-if="hasPermission('contact.settlement-of-account')">
              <a
                class="tab"
                :class="{ 'active': tabs.top.active === 'statement-of-account' }"
                @click="tabs.top.active = 'statement-of-account'"
                >
                Statement of account
              </a>
            </li>
            <li class="flex-1" v-if="hasPermission('contact.mass-settle')">
              <a
                class="tab"
                :class="{ 'active': tabs.top.active === 'unsettled-invoices' }"
                @click="tabs.top.active = 'unsettled-invoices'"
                >
                Unsettled Invoices
              </a>
            </li>
          </ul>

          <div v-if="hasPermission('job.view') && tabs.top.active === 'jobs'">
            <job-list
              :customerID="customerID"
              :showCustomerColumn="false"
            ></job-list>
          </div>
          <div v-if="hasPermission('vehicle.view') && tabs.top.active === 'vehicles'">
            <vehicle-list
              :customerID="customerID"
              :showCustomerColumn="false"
            ></vehicle-list>
          </div>
          <div v-if="hasPermission('customer.edit') && tabs.top.active === 'edit'">
            <edit-customer
              :contactID="customerID"
              @updated="getCustomer"
            ></edit-customer>
          </div>
          <div v-if="hasPermission('contact.settlement-of-account') && tabs.top.active === 'statement-of-account'">
            <statement-of-account
              :contactID="customerID"
              contactType="customer"
            ></statement-of-account>
          </div>
          <div v-if="hasPermission('contact.mass-settle') && tabs.top.active === 'unsettled-invoices'">
            <invoice-settle
              :contactID="customerID"
              contactType="customer"
              paymentType="income"
            ></invoice-settle>
          </div>
        </div>
      </div>
    </div>

  </div>
</template>


<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
const EditCustomer = resolve => require(['@/components/pages/contacts/Edit'], resolve)
const VehicleList = resolve => require(['@/components/pages/vehicles/List'], resolve)
const JobList = resolve => require(['@/components/pages/jobs/List'], resolve)
const ContactInformation = resolve => require(['@/components/pages/ContactInformation'], resolve)
const InvoiceSettle = resolve => require(['@/components/pages/invoices/Settle'], resolve)
const StatementOfAccount = resolve => require(['@/components/pages/reports/StatementOfAccount'], resolve)

export default {
  components: {
    EditCustomer,
    VehicleList,
    JobList,
    ContactInformation,
    InvoiceSettle,
    StatementOfAccount,
  },
  data() {
    return {
      customerID: this.$route.params.customerID,
      customer: {},
      tabs: {
        top: {
          active: 'jobs',
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      hasPermission: 'user/hasPermission',
    })
  },
  mounted() {
    this.getCustomer()
  },
  methods: {
    availableTab() {
      if (this.hasPermission('job.view')) {
        return 'jobs'
      }
      if (this.hasPermission('vehicle.view')) {
        return 'vehicles'
      }
      if (this.hasPermission('customer.edit')) {
        return 'edit'
      }
      if (this.hasPermission('contact.settlement-of-account')) {
        return 'statement-of-account'
      }
      if (this.hasPermission('contact.mass-settle')) {
        return 'unsettled-invoices'
      }
      return ''
    },
    getCustomer() {
      axios.get('customers/' + this.customerID)
        .then((response) => {
          const customer = response.data

          // sort by type (primary first)
          customer.phone_numbers.sort((a) => {
            return a.type === 'primary' ? -1 : 1
          })

          this.tabs.top.active = this.availableTab()

          this.customer = Object.assign({}, customer)
        })
        .catch((error) => {
          console.log(error.response)
          this.$swal.fire({
            title: 'Customer not found',
            type: 'warning',
          })
            .then(() => {
              this.$router.push('/customer/list')
            })
        })
    }
  }
}
</script>
